import { render, staticRenderFns } from "./updateSettings.vue?vue&type=template&id=8d0caf6e"
import script from "./updateSettings.vue?vue&type=script&lang=js"
export * from "./updateSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports